import React from "react";
import { Link } from "react-router-dom";
import Map from "../Map/Map";
import ContactData from "../Navbar/ContactData";
import CopyRight from "./CopyRight";
import "./Footer.css";

function Footer() {
  return (
    <>
      <footer>
        <div className="footerTop px-1 px-sm-3 py-3 text-center">
          <div className="mb-0 d-flex text-light align-items-center justify-content-around flex-column flex-xl-row">
            <p className="address  d-flex align-items-center mb-2 mb-xl-0 flex-column flex-md-row">
              <i className="fa fa-map-marker mb-2 mb-md-0 d-none d-md-flex"></i>
              #48/11, 11th Main, 13th Cross, Malleswaram, Bengaluru, Karnataka,
              India 560003
            </p>
            <div className="contact d-flex align-items-center">
              <div className="icons d-flex ml-1">
                <a href={`tel:${ContactData.phone}`}>
                  {" "}
                  <i className="mx-2 fa fa-phone"></i>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://wa.me/${ContactData.whatsapp}`}
                >
                  {" "}
                  <i className="mx-2 fa fa-whatsapp"></i>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://telegram.me/${ContactData.telegram}`}
                >
                  {" "}
                  <i className="mx-2 fa fa-telegram"></i>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    window.matchMedia("(max-width: 786px)").matches
                      ? `mailto:${ContactData.mail}`
                      : `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${ContactData.mail}`
                  }
                >
                  {" "}
                  <i className="mx-2 fa fa-envelope"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Added Code */}
        <div>
          <Map></Map>
        </div>
        <div className="footerMiddle px-1 px-sm-4 py-3 row mx-0 justify-content-center">
          <div className="col-sm-12 col-md-3  text-sm-left text-md-center">
            {/* <a href="{PDF}" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{" "} */}
            <Link to="/privacyPolicy">Privacy Policy</Link>{" "}
          </div>
          <div className="col-sm-12 col-md-3  text-sm-left text-md-center">
            {/* <a href="{PDF}" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>{" "} */}
            <Link to="/termCondition">Terms & Conditions</Link>{" "}
          </div>
          {/* <div className="col-sm-12  col-md-3  text-sm-left text-md-center mb-0">
            <p className="cursor-pointer mb-0 d-inline">Careers</p>
          </div> */}
          <div className="col-sm-12  col-md-3 text-sm-left text-md-center mb-0 ">
            <p className="mb-0 d-inline">
              GST NO: <span>1234 5678 9101 1121</span>{" "}
            </p>
          </div>
        </div>
        <CopyRight></CopyRight>
      </footer>
    </>
  );
}

export default Footer;
